import {
  Credential,
  CredentialEntity,
  DropboxCredential,
  DropboxCredentialToCredentialEntityMapper,
} from '@uploadcam/common';
import { RefreshCredentialAdapterInteractor } from '../../auth/domain/interactors/refresh-credential.interactor';

export class RefreshDropboxCredentialInteractor implements RefreshCredentialAdapterInteractor {
  constructor(private readonly clientId: string) {}

  public async execute(credential: Credential): Promise<CredentialEntity> {
    const mapper = new DropboxCredentialToCredentialEntityMapper(Date.now());
    const res = await fetch('https://api.dropbox.com/oauth2/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: credential.refreshToken,
        client_id: this.clientId,
      }),
    });

    const body = await res.json();

    const cred: DropboxCredential = {
      // Refresh token is reused
      refresh_token: credential.refreshToken,
      access_token: body.access_token,
      expires_in: body.expires_in,
      scope: credential.scopes.join(' '),
    };

    return mapper.map(cred);
  }
}
